module.exports = __webpack_public_path__ + "assets/img/modal-avatar-f082429b.png";